import { LOADING_MERCHANT, SET_MERCHANT, FINISH_SET_MERCHANT } from './actions';

const initialState = {
  merchant: {},
  isLoading: false,
  isSetMerchantFinished: false,
};

export default function merchant(state = initialState, action) {
  switch (action.type) {
    case LOADING_MERCHANT:
      return {
        ...state,
        isLoading: true,
      };
    case SET_MERCHANT:
      return {
        ...state,
        merchant: action.payload,
        isSetMerchantFinished: true,
      };
    case FINISH_SET_MERCHANT:
      return {
        ...state,
        isSetMerchantFinished: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/merchant/reducer.js